import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";

import RegistrarCotizacion from "components/RegistrarCotizacion";
import DetallesCotizacion from "components/DetallesCotizacion";

// const API_URL = ... (removed)
const empresaId = localStorage.getItem("empresaId") || "1";

export default function Cotizaciones() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const [filtro, setFiltro] = useState("");
  const [cotizaciones, setCotizaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estados para los modals
  const [openRegistrar, setOpenRegistrar] = useState(false);
  const [openDetalles, setOpenDetalles] = useState(false);
  const [selectedCotizacion, setSelectedCotizacion] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  useEffect(() => {
    fetchCotizaciones();
  }, []);

  const fetchCotizaciones = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.COTIZACIONES, {
        params: { empresa_id: empresaId },
      });
      setCotizaciones(response.data);
    } catch (error) {
      console.error("Error al cargar cotizaciones:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenRegistrar = () => setOpenRegistrar(true);
  const handleCloseRegistrar = () => setOpenRegistrar(false);

  const handleOpenDetalles = async (id) => {
    try {
      setLoadingDetails(true);
      const response = await axios.get(API_ENDPOINTS.COTIZACION(id));
      setSelectedCotizacion(response.data);
      setOpenDetalles(true);
    } catch (error) {
      console.error("Error al obtener detalles de la cotización:", error);
      alert("No se pudo cargar la información de la cotización.");
    } finally {
      setLoadingDetails(false);
    }
  };

  const handleCloseDetalles = () => {
    setOpenDetalles(false);
    setSelectedCotizacion(null);
  };

  const cotizacionesFiltradas = cotizaciones.filter(
    (cot) =>
      cot.folio?.toLowerCase().includes(filtro.toLowerCase()) ||
      cot.proveedor?.nombre?.toLowerCase().includes(filtro.toLowerCase())
  );

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case "vigente":
        return "info";
      case "aceptada":
        return "success";
      case "rechazada":
        return "error";
      case "vencida":
        return "warning";
      default:
        return "default";
    }
  };

  const columns = [
    { Header: "Folio", accessor: "folio", width: "15%" },
    { Header: "Proveedor", accessor: "proveedor", width: "25%" },
    { Header: "Fecha", accessor: "fecha", width: "12%" },
    { Header: "Vigencia", accessor: "vigencia", width: "12%" },
    { Header: "Total", accessor: "total", width: "15%" },
    { Header: "Estatus", accessor: "estatus", align: "center", width: "12%" },
    { Header: "Acciones", accessor: "acciones", align: "center", width: "9%" },
  ];

  const rows = cotizacionesFiltradas.map((cot) => ({
    folio: cot.folio,
    proveedor: cot.proveedor?.nombre || "N/A",
    fecha: new Date(cot.fecha_cotizacion).toLocaleDateString("es-MX"),
    vigencia: new Date(cot.fecha_vigencia).toLocaleDateString("es-MX"),
    total: `$${parseFloat(cot.total || 0).toLocaleString("es-MX", {
      minimumFractionDigits: 2,
    })}`,
    estatus: <Chip label={cot.estatus} color={getEstatusColor(cot.estatus)} size="small" />,
    acciones: (
      <Icon
        sx={{ cursor: "pointer", fontSize: 20 }}
        color="info"
        onClick={() => handleOpenDetalles(cot.id)}
      >
        visibility
      </Icon>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={8}>
          <MDInput
            label="Buscar cotización"
            fullWidth
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            placeholder="Folio o proveedor"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <MDButton
            variant="gradient"
            color={sidenavColor}
            fullWidth
            onClick={handleOpenRegistrar}
          >
            <Icon sx={{ mr: 1 }}>add</Icon>
            Nueva Cotización
          </MDButton>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDTypography variant="h6" mb={2}>
            <Icon sx={{ mr: 1 }}>request_quote</Icon>
            Cotizaciones ({cotizacionesFiltradas.length})
          </MDTypography>
          {loading ? (
            <MDTypography variant="body2">Cargando cotizaciones...</MDTypography>
          ) : (
            <DataTable
              table={{ columns, rows }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={false}
            />
          )}
        </MDBox>
      </Card>

      <RegistrarCotizacion
        open={openRegistrar}
        onClose={handleCloseRegistrar}
        onSuccess={fetchCotizaciones}
      />

      <DetallesCotizacion
        open={openDetalles}
        onClose={handleCloseDetalles}
        cotizacion={selectedCotizacion}
      />
    </MDBox>
  );
}
